// extracted by mini-css-extract-plugin
module.exports = {"information":"df5dab2e92--information--29b0i","questions":"df5dab2e92--questions--1n04c"};